import { useSheetStore } from "@/shared/stores";
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@spz/ui/components/sheet";
import { cn } from "@spz/ui/lib/utils";
import { useEffect } from "react";
import { useLocation } from "react-router";

export const GlobalSheet = () => {
  const {
    isOpen,
    title,
    content,
    footer,
    width,
    header,
    enableFullscreen,
    enableCopyUrl,
    isFullscreen,
    onToggleFullscreen,
    closeSheet,
  } = useSheetStore();
  const location = useLocation();

  const onCopyCurrentUrl = () => {
    navigator.clipboard.writeText(window.location.href);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: Whenever the pathname changes, we want to close the sheet
  useEffect(() => {
    if (isOpen) {
      closeSheet();
    }
  }, [location.pathname]);

  return (
    <div className={cn("relative")} style={{ isolation: "isolate" }}>
      <Sheet open={isOpen} modal={false} onOpenChange={closeSheet}>
        <SheetContent
          side="right"
          className="border-l border-gray-200 bg-gray-50 flex flex-col h-full"
          style={{
            position: "fixed",
            right: 0,
            top: 0,
            bottom: 0,
            width: width,
            zIndex: 40,
          }}
          onPointerDownOutside={(e) => {
            e.preventDefault();
          }}
          onInteractOutside={(e) => {
            e.preventDefault();
          }}
          header={header}
          enableFullscreen={enableFullscreen}
          enableCopyUrl={enableCopyUrl}
          onToggleFullscreen={onToggleFullscreen}
          isFullscreen={isFullscreen}
          onCopyUrl={onCopyCurrentUrl}
        >
          <SheetHeader className="flex flex-row items-center justify-between">
            {title && <SheetTitle>{title}</SheetTitle>}
          </SheetHeader>
          <div className="flex-1 overflow-y-auto py-4 mb-auto">{content}</div>

          {footer && (
            <SheetFooter className="border-t border-gray-200 pt-4 p-4 pr-6 pl-6 mt-auto">
              <div className="flex justify-end gap-2 w-full">{footer}</div>
            </SheetFooter>
          )}
        </SheetContent>
      </Sheet>
    </div>
  );
};
